export default __webpack_public_path__ + "static/media/pip.b605f45c.svg";